import React from 'react';
import { FaArrowAltCircleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import styled from "styled-components";

const ProjectCard = (props) => {
  return (
    <Container>
        <Img src={props.image} alt="project image" />
        <Wrap>
            <Title>{props.title}</Title>
            <Description>{props.description}</Description>
            <SeeMoreHold to={props.link}>
                <span>See more</span>
                <FaArrowAltCircleRight/>
            </SeeMoreHold>
        </Wrap>
    </Container>
  )
}

export default ProjectCard;

const Container = styled.div`
width: 30%;
height: 270px;
display: flex;
flex-direction: column;
/* justify-content: center; */
align-items: center;
background-color: white;
border-radius: 10px;
margin: 10px 0;
box-shadow: rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px;

:hover{
    cursor: pointer;
}


@media Screen and (max-width: 768px){
    width: 85%;
}
@media Screen and (max-width: 425px){
    width: 95%;
}
`;
const Wrap = styled.div`
width: 100%;
/* background-color: tomato; */
height: 40%;
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
`;
const Img = styled.img`
width: 100%;
height: 60%;
object-fit: cover;
border-radius: 10px 10px 0 0;
`;
const Title = styled.div`
font-size: 18px;
font-weight: bold;
background: linear-gradient( 150deg ,indigo 30%, green 54.05%, orangered 65%);
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;

:hover{
background: #2b2c2c;
background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
}
`;
const Description = styled.div`
color: #2b2c2c;
font-size: 15px;
font-weight: bold;
padding: 0 10px;
text-align: center;
`;
const SeeMoreHold = styled(Link)`
font-weight: 500;
color: #2b2c2c;
display: flex;
justify-content: space-between;
align-items: center;
width: 22%;
margin-top: 10px;
/* background-color: rosybrown; */
    background: linear-gradient( 150deg ,indigo 30%, green 54.05%, orangered 65%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    /* transition: 1s; */

:hover{
    background:  #2b2c2c;
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    cursor: pointer;
    transform: scale(1.05);

}

@media Screen and (max-width: 425px){
    width: 35%;
}
`;


